/* eslint-disable @next/next/no-img-element */
import CustomTrustpilotLogo from 'components/common/CustomTrustpilotLogo';
import { EntryMethod, EntryMethodDetails } from 'components/enter/EntryMethod';
import PageTitle, { PageTitleColourScheme } from 'components/PageTitle';
import { extendClassName } from 'utils/common';
import { ASSET_PREFIX, colors, PRIZE_NUMBERS } from 'utils/constants';

interface IPlayPageTitle {
  preselectedEntryMethod: keyof typeof EntryMethod;
  additionalClassName?: string;
}
const PlayPageTitle = ({
  preselectedEntryMethod,
  additionalClassName = undefined,
}: IPlayPageTitle) => {
  return (
    <div
      className={extendClassName(
        'playPremiumLitePageTitle fullWidth flexCentered',
        additionalClassName,
      )}
    >
      <PageTitle
        Tag="div"
        tagClassName="titleText mt-9 md:mt-12 paddedMaxWidthContainer"
        heroBackgroundImage={`${ASSET_PREFIX}/images/enter/page-title-background-premium-lite.svg`}
        colourScheme={PageTitleColourScheme[preselectedEntryMethod]}
        subheadingComponent={undefined}
        style={undefined}
      >
        <h1
          className="big-font-desktop normal-case"
          style={{ textAlign: 'inherit', fontSize: 28 }}
        >
          Play {EntryMethodDetails[preselectedEntryMethod].name}
        </h1>
        {preselectedEntryMethod === EntryMethod.PremiumSubscription && (
          <p className="medium" style={{ lineHeight: 1.5 }}>
            Your weekly chance to win any of our{' '}
            <strong>{PRIZE_NUMBERS.PREMIUM} prizes!</strong>
          </p>
        )}
        {preselectedEntryMethod === EntryMethod.LiteSubscription && (
          <p className="medium" style={{ lineHeight: 1.5 }}>
            Your chance to win any of{' '}
            <strong>{PRIZE_NUMBERS.LITE} prizes</strong> from 5 of our prize
            tiers!
          </p>
        )}
        {preselectedEntryMethod === EntryMethod.FreeSubscription && (
          <p className="medium" style={{ lineHeight: 1.5 }}>
            Your chance to win £2k of prizes <strong>FOR FREE!</strong>
          </p>
        )}

        <CustomTrustpilotLogo />
      </PageTitle>

      <style jsx>
        {`
          .big-font-desktop {
            font-size: 39px !important;
          }
          :global(.playPremiumLitePageTitle .titleText) {
            text-align: center;
            padding: 0.5em 0;
          }

          :global(.playPremiumLitePageTitle .titleText > *) {
            max-width: 320px;
          }

          :global(.playPremiumLitePageTitle .titleText .roundedButton) {
            width: 60%;
            max-width: 200px;
            margin-top: 0.5em;
          }

          :global(.playPremiumLitePageTitle .titleText .roundedButton:hover) {
            background: ${colors.primaryBrandGray}99;
          }

          .introductoryOfferBanner {
            position: absolute;
            left: 0;
            top: 0;
            width: 105px;
          }

          :global(.playPremiumLitePageTitle .customTrustpilotLogo) {
            width: 60%;
            max-width: 190px;
          }

          @media (max-width: 400px) {
            .big-font-desktop {
              font-size: 30px !important;
            }
          }

          @media (min-width: 1000px) {
            :global(.playPremiumLitePageTitle .titleText) {
              align-items: flex-start;
              text-align: left;
            }

            :global(.playPremiumLitePageTitle h1) {
              font-size: 2.8em;
            }

            :global(.playPremiumLitePageTitle .pageTitle) {
              padding: 1.5em 0;
            }

            :global(
                .playPremiumLitePageTitle
                  .pageTitle
                  .heroBackgroundImageContainer
              ) {
              left: 0;
              width: 100%;
            }

            :global(.playPremiumLitePageTitle .pageTitle .heroBackgroundImage) {
              right: unset;
            }

            // .introductoryOfferBanner {
            //   display: none;
            // }
          }
        `}
      </style>
    </div>
  );
};

export default PlayPageTitle;
